import React from "react";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { SxProps, TextField } from "@mui/material";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface PropertyEditorFloatInterface {
    editObject: object;
    propertyName: string;
    label?: string;
    hint?: string;
    onChange?: () => void;
    sx?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export const PropertyEditorFloat: React.FC<PropertyEditorFloatInterface> = (props: PropertyEditorFloatInterface) => {
    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                const propvalue = Reflect.get(props.editObject, props.propertyName);
                let validationIssues = getPropertyEditorValidationIssues(
                    props.editObject,
                    props.propertyName,
                    props.error,
                );
                return (
                    <PropertyEditorValidationTooltip
                        editObject={props.editObject}
                        propertyName={props.propertyName}
                        error={validationIssues}
                    >
                        <TextField
                            fullWidth={true}
                            sx={props.sx}
                            variant="outlined"
                            value={propvalue}
                            size={"small"}
                            data-testid={"property-editor-float"}
                            type="number"
                            error={Boolean(validationIssues?.message)}
                            label={props.label}
                            onBlur={(event) => {
                                try {
                                    let val = parseFloat(event.target.value);
                                    Reflect.set(props.editObject, props.propertyName, val);
                                    StateManager.propertyChanged(props.editObject, props.propertyName);
                                    if (props.onChange) props.onChange();
                                } catch {
                                    console.log("error");
                                }
                            }}
                            helperText={validationIssues?.message ?? props.hint}
                        />
                    </PropertyEditorValidationTooltip>
                );
            }}
        />
    );
};
